import React from 'react'
import { Link } from '../../utils'

export function SubSubMenu({subMenuItem, expanded, closeMenu}) {
  return (
    <div className="subSubMenu__wrapper">
      <ul className={`subSubMenu ps-0 mt-lg-2 mx-2 mx-lg-0  ${expanded ? 'subSubMenu-slidedown' : ''}`}>
        {/* SubSubMenuItems Ex: <li>Omaha Central</li> - <li>Omaha West</li>  */}
      { 
        subMenuItem.subSubMenu.map((subSubMenuItem, index) => (
          <li key={index}>
            <Link to={subSubMenuItem.pathname} onClick={closeMenu}>
              {subSubMenuItem.link}
            </Link>
          </li>
        ))
      }
      </ul>
    </div>
  )
}

export default SubSubMenu